import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/atoms/Button";
import MainLayoutDetail from "../../components/layout/MainLayoutDetail";
import SectionBox from "../../components/layout/SectionBox";
import { forgotPasswordApi } from "../../api/authApi";
import { toast } from "react-toastify";
// @ts-ignore
import ReCAPTCHA from "react-google-recaptcha";

export default function ForgotPassword() {
  const [formData, setFormData] = useState({ email: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);


  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const currentLang = location.pathname.startsWith("/id") ? "id" : "en";

  // const login = useAuthStore((state) => state.login);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!captchaToken) {
      toast.error("Please verify that you are not a robot");
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const res = await forgotPasswordApi(formData.email);

      toast.success(res.message || "Reset password link sent");

      setTimeout(() => {
        navigate(`/${currentLang}/login`);
      }, 1500);

    } catch (err: any) {
      // 🧠 ambil error message paling relevan
      const errorMessage =
        err?.errors?.email?.[0] ||
        err?.message ||
        "Something went wrong";

      toast.error(errorMessage);
      setError(errorMessage);

    } finally {
      setLoading(false);
    }
  };






  return (
    <MainLayoutDetail>
      <div className="container-section mx-auto mt-32 px-6">
        <SectionBox
          className="md:flex md:flex-col md:justify-center md:min-h-[70vh]"
          titleClassName="text-2xl md:text-3xl text-white"
          background="radial-gradient(circle at 50% -100%, rgba(255,255,255,0) 0%, #123b7c 70%)"
        >
          <div className="flex items-center justify-center">
            <form
              onSubmit={handleSubmit}
              className="bg-white p-4 md:p-8 rounded-2xl shadow-md w-96"
            >
              <h2 className="text-2xl font-semibold mb-2 text-gray-800 text-center">
                Forgot Password
              </h2>

              <p className="text-sm mb-6">
                Please enter your email and we will sent you link for reset password
              </p>

              <div className="flex flex-col gap-4">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="border border-gray-300 rounded-lg p-3 text-sm"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                {error && (
                  <p className="text-sm text-red-500 text-center">{error}</p>
                )}



                <ReCAPTCHA
                  sitekey="6LfPuzcsAAAAAItzND8FHtg9SJvsFhRNDZJmiMnH"
                  onChange={handleCaptchaChange}
                />

                <Button
                  type="submit"
                  disabled={loading}
                  className={`w-full bg-primary hover:bg-secondary ${loading ? "opacity-60 cursor-not-allowed" : ""
                    }`}
                >
                  {loading ? "Sending..." : "Send"}
                </Button>

              </div>
            </form>
          </div>
        </SectionBox>
      </div>
    </MainLayoutDetail>
  );
}
